/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { useRef, useEffect } from 'react';

import { ExtendedTableState } from './types';

export const useResizeObserver = (
    state: ExtendedTableState,
    callback: (columnId: string, columnSize: number) => void,
) => {
    // This Ref will contain the id of the column being resized or undefined
    const columnResizeRef = useRef<string | undefined>();
    useEffect(() => {
        // We are interested in calling the resize event only when "state.columnResizing?.isResizingColumn" changes from
        // a string to undefined, because it indicates that it WAS resizing but it no longer is.
        if (
            state.columnResizing &&
            !state.columnResizing?.isResizingColumn &&
            columnResizeRef.current
        ) {
            // Trigger resize event
            callback(
                columnResizeRef.current,
                state.columnResizing.columnWidths[columnResizeRef.current],
            );
        }
        columnResizeRef.current = state.columnResizing?.isResizingColumn;
    }, [state.columnResizing?.isResizingColumn]);
};
